









































































































































































import { Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';

import AppVue from '@/AppVue.vue';
import { QuestionnaireModel } from '@/core/models';
import { InputTextareaCpt } from '@/core/components';

@Component({
  components: {
    InputTextareaCpt,
  },
})
export default class QuestionnaireStep1Cpt extends AppVue {
  @Prop() model: QuestionnaireModel;
  @Prop({ default: false }) disabled: boolean;
}
